import { ToolbarProps } from 'react-big-calendar'
import { common } from '@ocean/ui'
import {
  Wrapper,
  Label,
  ViewButtonGroup,
  ViewButton,
  NavigationButtonGroup,
  NavigationButton,
  TodayDot,
} from './Toolbar.styled'

const { Typography, Icon } = common

const Toolbar: React.FC<ToolbarProps<any, any>> = props => {
  const { label, views, view: currentView, localizer, onNavigate, onView } = props
  const { messages } = localizer

  function renderViewButtons() {
    if (!Array.isArray(views)) return null
    return (
      <ViewButtonGroup>
        {views.map(view => (
          <ViewButton key={view} isActive={view === currentView} onClick={() => onView(view)}>
            <Typography variant='h4' dataTest={`ToolbarChangeViewButton-${view}`}>
              {messages[view]}
            </Typography>
          </ViewButton>
        ))}
      </ViewButtonGroup>
    )
  }

  function renderNavigationButtons() {
    return (
      <NavigationButtonGroup>
        <NavigationButton
          title={messages.today}
          onClick={() => onNavigate('TODAY')}
          data-test='ToolbarNavigationTodayButton'
        >
          <TodayDot />
        </NavigationButton>
        <NavigationButton
          title={messages.previous}
          onClick={() => onNavigate('PREV')}
          data-test='ToolbarNavigationPrevButton'
        >
          <Icon icon='larr' />
        </NavigationButton>
        <NavigationButton
          title={messages.next}
          onClick={() => onNavigate('NEXT')}
          data-test='ToolbarNavigationNextButton'
        >
          <Icon icon='rarr' />
        </NavigationButton>
      </NavigationButtonGroup>
    )
  }

  return (
    <Wrapper>
      {renderNavigationButtons()}
      <Label data-test='ToolbarLabel'>{label}</Label>
      {renderViewButtons()}
    </Wrapper>
  )
}

export default Toolbar
